/* React */
import React from "react";

/* Utils */
import ContentPageWrapper from "src/utils/wrapper/content-page-wrapper/ContentPageWrapper";
import PageWrapper from "src/utils/wrapper/page-wrapper/PageWrapper";

/* Components */
import Content from "src/components/imprint/content/Content";

const Imprint: React.FC = () => {
  return (
    <PageWrapper>
      <ContentPageWrapper>
        <Content />
      </ContentPageWrapper>
    </PageWrapper>
  );
};

export default Imprint;
